import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { mainApi } from "../../api/axios";
import { settleOrder } from "./cartSlice";
import { ORDER_STATUS } from "../../constants/enums";

/**
 * Get All Orders
 */
export const getAllOrders = createAsyncThunk(
  "order/getAllOrders",
  async (params, { rejectWithValue }) => {
    try {
      const { storeId, offset, limit, status } = params;
      const res = await mainApi.get("/v1/pos/orders", {
        params: params,
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

const initialState = {
  orderList: [],
  loading: false,
  error: null,
  totalCount: 0,
  filters: {
    status: ORDER_STATUS.IN_PROGRESS,
    orderType: 0,
    paymentStatus: 0,
    diningArea: 0,
    fromDate: null,
    toDate: null,
  },
};

// Slice
const orderSlice = createSlice({
  name: "order",
  initialState: initialState,
  reducers: {
    clearOrderState: (state) => {
      state.orderList = [];
      state.totalCount = 0;
      state.loading = false;
      state.error = null;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get all orders
      .addCase(getAllOrders.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orderList = action.payload.orders;
        state.totalCount = action.payload.total_orders;
      })
      .addCase(getAllOrders.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { clearOrderState, setFilters, resetFilters } = orderSlice.actions;
export default orderSlice.reducer;
